import React, { useEffect, useState, useContext, useRef, useCallback } from "react";

import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";

import useSettings from "../../hooks/useSettings";
import { ToastContainer, toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";

import { Tab, Tabs, TextField, Button, Typography, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, InputAdornment } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DescriptionIcon from "@material-ui/icons/Description";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { i18n } from "../../translate/i18n";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  tab: {
    backgroundColor: theme.mode === 'light' ? "#f2f2f2" : "#7f7f7f",
    borderRadius: 4,
    width: "100%",
    "& .MuiTabs-flexContainer": {
      justifyContent: "center"
    }
  },
  infoBox: {
    padding: '16px',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    border: '1px solid #e0e0e0'
  },
  infoTitle: {
    margin: '0 0 8px 0',
    color: '#1976d2'
  },
  infoText: {
    margin: '4px 0',
    fontSize: '14px',
    color: '#666'
  },
  termsUploadBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '20px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#fafafa',
  },
  termsFileRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  termsFileName: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: '#555',
    backgroundColor: '#e8f5e9',
    padding: '4px 10px',
    borderRadius: '4px',
  },
  termsButtonRow: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  }
}));

export default function Options(props) {
  const { oldSettings, settings, scheduleTypeChanged, user } = props;

  const classes = useStyles();
  const [userRating, setUserRating] = useState("disabled");
  const [scheduleType, setScheduleType] = useState("disabled");
  const [chatBotType, setChatBotType] = useState("text");

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);

  const [userCreation, setUserCreation] = useState("disabled");
  const [loadingUserCreation, setLoadingUserCreation] = useState(false);

  // #4155: mesclar o histórico do ticket entre as conexões do mesmo contato.
  // "true" = ticket mostra o histórico de todas as conexões; ausente/"false"
  // (padrão) = isola por conexão.
  const [mergeHistoryByContact, setMergeHistoryByContact] = useState("false");
  const [loadingMergeHistoryByContact, setLoadingMergeHistoryByContact] = useState(false);

  const [SendGreetingAccepted, setSendGreetingAccepted] = useState("enabled");
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);

  const [UserRandom, setUserRandom] = useState("enabled");
  const [loadingUserRandom, setLoadingUserRandom] = useState(false);

  const [SettingsTransfTicket, setSettingsTransfTicket] = useState("enabled");
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);

  const [AcceptCallWhatsapp, setAcceptCallWhatsapp] = useState("enabled");
  const [loadingAcceptCallWhatsapp, setLoadingAcceptCallWhatsapp] = useState(false);

  const [sendSignMessage, setSendSignMessage] = useState("enabled");
  const [loadingSendSignMessage, setLoadingSendSignMessage] = useState(false);
  // #4343: ha clientes que querem a primeira letra da mensagem em maiuscula e
  // clientes que nao querem. Padrao "enabled" — era o comportamento fixo.
  const [autoCapitalizeMessage, setAutoCapitalizeMessage] = useState("enabled");
  const [loadingAutoCapitalizeMessage, setLoadingAutoCapitalizeMessage] = useState(false);

  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState("enabled");
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);

  const [sendQueuePosition, setSendQueuePosition] = useState("enabled");
  const [loadingSendQueuePosition, setLoadingSendQueuePosition] = useState(false);

  const [sendFarewellWaitingTicket, setSendFarewellWaitingTicket] = useState("enabled");
  const [loadingSendFarewellWaitingTicket, setLoadingSendFarewellWaitingTicket] = useState(false);


  //PAYMENT METHODS
  const [eficlientidType, setEfiClientidType] = useState('');
  const [loadingEfiClientidType, setLoadingEfiClientidType] = useState(false);

  const [eficlientsecretType, setEfiClientsecretType] = useState('');
  const [loadingEfiClientsecretType, setLoadingEfiClientsecretType] =
    useState(false);

  const [efichavepixType, setEfiChavepixType] = useState('');
  const [loadingEfiChavepixType, setLoadingEfiChavepixType] = useState(false);

  const [mpaccesstokenType, setmpaccesstokenType] = useState('');
  const [loadingmpaccesstokenType, setLoadingmpaccesstokenType] =
    useState(false);

  const [stripeprivatekeyType, setstripeprivatekeyType] = useState('');
  const [loadingstripeprivatekeyType, setLoadingstripeprivatekeyType] =
    useState(false);

  const [asaastokenType, setasaastokenType] = useState('');
  const [loadingasaastokenType, setLoadingasaastokenType] = useState(false);

  const [smtpHost, setSmtpHost] = useState("");
  const [loadingSmtpHost, setLoadingSmtpHost] = useState(false);
  const [smtpPort, setSmtpPort] = useState("");
  const [loadingSmtpPort, setLoadingSmtpPort] = useState(false);
  const [smtpUser, setSmtpUser] = useState("");
  const [loadingSmtpUser, setLoadingSmtpUser] = useState(false);
  const [smtpPass, setSmtpPass] = useState("");
  const [loadingSmtpPass, setLoadingSmtpPass] = useState(false);
  const [smtpFrom, setSmtpFrom] = useState("");
  const [loadingSmtpFrom, setLoadingSmtpFrom] = useState(false);
  const [frontendUrl, setFrontendUrl] = useState("");
  const [loadingFrontendUrl, setLoadingFrontendUrl] = useState(false);
  const [testEmailTo, setTestEmailTo] = useState("");
  const [testEmailLang, setTestEmailLang] = useState("pt");
  const [sendingTestEmail, setSendingTestEmail] = useState(false);

  const smtpDebounceTimers = useRef({});

  //OPENAI API KEY TRANSCRIÇÃO DE ÁUDIO
  const [openaiToken, setOpenaiToken] = useState('');
  const [loadingOpenaiToken, setLoadingOpenaiToken] = useState(false);
  const openaiTokenDebounceRef = useRef(null);

  //LGPD
  const [enableLGPD, setEnableLGPD] = useState("disabled");
  const [loadingEnableLGPD, setLoadingEnableLGPD] = useState(false);

  const [lgpdMessage, setLGPDMessage] = useState("");
  const [loadinglgpdMessage, setLoadingLGPDMessage] = useState(false);

  const [lgpdLink, setLGPDLink] = useState("");
  const [loadingLGPDLink, setLoadingLGPDLink] = useState(false);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState("disabled");
  const [loadingLGPDDeleteMessage, setLoadingLGPDDeleteMessage] = useState(false);

  //LIMITAR DOWNLOAD
  // const [downloadLimit, setdownloadLimit] = useState("64");
  // const [loadingDownloadLimit, setLoadingdownloadLimit] = useState(false);

  const [lgpdConsent, setLGPDConsent] = useState("disabled");
  const [loadingLGPDConsent, setLoadingLGPDConsent] = useState(false);

  const [lgpdHideNumber, setLGPDHideNumber] = useState("disabled");
  const [loadingLGPDHideNumber, setLoadingLGPDHideNumber] = useState(false);

  // Tag obrigatoria
  const [requiredTag, setRequiredTag] = useState("enabled")
  const [loadingRequiredTag, setLoadingRequiredTag] = useState(false)

  // Fechar ticket ao transferir para outro setor
  const [closeTicketOnTransfer, setCloseTicketOnTransfer] = useState(false)
  const [loadingCloseTicketOnTransfer, setLoadingCloseTicketOnTransfer] = useState(false)

  // Usar carteira de clientes
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false)
  const [loadingDirectTicketsToWallets, setLoadingDirectTicketsToWallets] = useState(false)

  // Sigla para inserir no copiar contatos
  const [copyContactPrefix, setCopyContactPrefix] = useState("");
const [loadingCopyContactPrefix, setLoadingCopyContactPrefix] = useState(false);

  //MENSAGENS CUSTOMIZADAS
  const [transferMessage, setTransferMessage] = useState("");
  const [loadingTransferMessage, setLoadingTransferMessage] = useState(false);

  const [greetingAcceptedMessage, setGreetingAcceptedMessage] = useState("");
  const [loadingGreetingAcceptedMessage, setLoadingGreetingAcceptedMessage] = useState(false);

  const [AcceptCallWhatsappMessage, setAcceptCallWhatsappMessage] = useState("");
  const [loadingAcceptCallWhatsappMessage, setLoadingAcceptCallWhatsappMessage] = useState(false);

  const [sendQueuePositionMessage, setSendQueuePositionMessage] = useState("");
  const [loadingSendQueuePositionMessage, setLoadingSendQueuePositionMessage] = useState(false);

  const [showNotificationPending, setShowNotificationPending] = useState(false);
  const [loadingShowNotificationPending, setLoadingShowNotificationPending] = useState(false);

  // Configurações de vencimento do plano
  const [gracePeriodDays, setGracePeriodDays] = useState("7");
  const [loadingGracePeriodDays, setLoadingGracePeriodDays] = useState(false);
  const [whatsappDisconnectGracePeriodDays, setWhatsappDisconnectGracePeriodDays] = useState("3");
  const [loadingWhatsappDisconnectGracePeriodDays, setLoadingWhatsappDisconnectGracePeriodDays] = useState(false);
  const [disconnectWhatsappOnExpiry, setDisconnectWhatsappOnExpiry] = useState(false);
  const [loadingDisconnectWhatsappOnExpiry, setLoadingDisconnectWhatsappOnExpiry] = useState(false);

  // Termos de uso
  const [termsFile, setTermsFile] = useState(null);
  const [termsFileName, setTermsFileName] = useState("");
  const [uploadingTerms, setUploadingTerms] = useState(false);
  const [termsPreviewOpen, setTermsPreviewOpen] = useState(false);
  const [termsPreviewHtml, setTermsPreviewHtml] = useState("");
  const [loadingPreview, setLoadingPreview] = useState(false);

  const { update: updateUserCreation, getAll, sendTestEmail } = useSettings();
  const { update: updateMergeHistoryByContact } = useSettings();

  // const { update: updatedownloadLimit } = useSettings();

  const { update: updateeficlientid } = useSettings();
  const { update: updateeficlientsecret } = useSettings();
  const { update: updateefichavepix } = useSettings();
  const { update: updatempaccesstoken } = useSettings();
  const { update: updatestripeprivatekey } = useSettings();
  const { update: updateasaastoken } = useSettings();

  const { update } = useCompanySettings();

  const isSuper = () => {
    return user.super;
  };

  const isAdminCompany = () => {
    return user.super;
  };

  const isMasterCompany = () => {
    return user.super && user.companyId === 1;
  };


  useEffect(() => {

    if (Array.isArray(oldSettings) && oldSettings.length) {

      const userPar = oldSettings.find((s) => s.key === "userCreation");

      if (userPar) {
        setUserCreation(userPar.value);
      }

      const mergeHistorySetting = oldSettings.find((s) => s.key === "mergeHistoryByContact");
      if (mergeHistorySetting) {
        setMergeHistoryByContact(mergeHistorySetting.value);
      }

      // const downloadLimit = oldSettings.find((s) => s.key === "downloadLimit");

      // if (downloadLimit) {
      //  setdownloadLimit(downloadLimit.value);
      // }

      const copyContactPrefix = oldSettings.find((s) => s.key === 'copyContactPrefix');
      if (copyContactPrefix) {
        setCopyContactPrefix(copyContactPrefix.value);
      }

      const eficlientidType = oldSettings.find((s) => s.key === 'eficlientid');
      if (eficlientidType) {
        setEfiClientidType(eficlientidType.value);
      }

      const eficlientsecretType = oldSettings.find((s) => s.key === 'eficlientsecret');
      if (eficlientsecretType) {
        setEfiClientsecretType(eficlientsecretType.value);
      }

      const efichavepixType = oldSettings.find((s) => s.key === 'efichavepix');
      if (efichavepixType) {
        setEfiChavepixType(efichavepixType.value);
      }

      const mpaccesstokenType = oldSettings.find((s) => s.key === 'mpaccesstoken');
      if (mpaccesstokenType) {
        setmpaccesstokenType(mpaccesstokenType.value);
      }

      const asaastokenType = oldSettings.find((s) => s.key === 'asaastoken');
      if (asaastokenType) {
        setasaastokenType(asaastokenType.value);
      }

      const smtpHostSetting = oldSettings.find((s) => s.key === "smtpHost");
      if (smtpHostSetting) {
        setSmtpHost(smtpHostSetting.value);
      }

      const smtpPortSetting = oldSettings.find((s) => s.key === "smtpPort");
      if (smtpPortSetting) {
        setSmtpPort(smtpPortSetting.value);
      }

      const smtpUserSetting = oldSettings.find((s) => s.key === "smtpUser");
      if (smtpUserSetting) {
        setSmtpUser(smtpUserSetting.value);
      }

      const smtpPassSetting = oldSettings.find((s) => s.key === "smtpPass");
      if (smtpPassSetting) {
        setSmtpPass(smtpPassSetting.value);
      }

      const smtpFromSetting = oldSettings.find((s) => s.key === "smtpFrom");
      if (smtpFromSetting) {
        setSmtpFrom(smtpFromSetting.value);
      }

      const frontendUrlSetting = oldSettings.find((s) => s.key === "frontendUrl");
      if (frontendUrlSetting) {
        setFrontendUrl(frontendUrlSetting.value);
      }

    }
  }, [oldSettings])


  useEffect(() => {
    for (const [key, value] of Object.entries(settings)) {
      if (key === "userRating") setUserRating(value);
      if (key === "scheduleType") setScheduleType(value);
      if (key === "chatBotType") setChatBotType(value);
      if (key === "acceptCallWhatsapp") setAcceptCallWhatsapp(value);
      if (key === "userRandom") setUserRandom(value);
      if (key === "sendGreetingMessageOneQueues") setSendGreetingMessageOneQueues(value);
      if (key === "sendSignMessage") setSendSignMessage(value);
      if (key === "autoCapitalizeMessage") setAutoCapitalizeMessage(value);
      if (key === "sendFarewellWaitingTicket") setSendFarewellWaitingTicket(value);
      if (key === "sendGreetingAccepted") setSendGreetingAccepted(value);
      if (key === "sendQueuePosition") setSendQueuePosition(value);
      if (key === "enableLGPD") setEnableLGPD(value);
      if (key === "requiredTag") setRequiredTag(value);
      if (key === "lgpdDeleteMessage") setLGPDDeleteMessage(value)
      if (key === "lgpdHideNumber") setLGPDHideNumber(value);
      if (key === "lgpdConsent") setLGPDConsent(value);
      if (key === "lgpdMessage") setLGPDMessage(value);
      if (key === "sendMsgTransfTicket") setSettingsTransfTicket(value);
      if (key === "lgpdLink") setLGPDLink(value);
      if (key === "DirectTicketsToWallets") setDirectTicketsToWallets(value);
      if (key === "closeTicketOnTransfer") setCloseTicketOnTransfer(value);
      if (key === "transferMessage") setTransferMessage(value);
      if (key === "greetingAcceptedMessage") setGreetingAcceptedMessage(value);
      if (key === "AcceptCallWhatsappMessage") setAcceptCallWhatsappMessage(value);
      if (key === "sendQueuePositionMessage") setSendQueuePositionMessage(value);
      if (key === "showNotificationPending") setShowNotificationPending(value);

      if (key === "copyContactPrefix") setCopyContactPrefix(value);
      if (key === "planExpiryGracePeriodDays") setGracePeriodDays(value);
      if (key === "disconnectWhatsappOnExpiry") setDisconnectWhatsappOnExpiry(value === "true" || value === true);
      if (key === "openaiToken") setOpenaiToken(value || "");
    }
  }, [settings]);

  async function handleChangeUserCreation(value) {
    setUserCreation(value);
    setLoadingUserCreation(true);
    await updateUserCreation({
      key: "userCreation",
      value,
    });
    setLoadingUserCreation(false);
  }

  async function handleChangeMergeHistoryByContact(value) {
    setMergeHistoryByContact(value);
    setLoadingMergeHistoryByContact(true);
    await updateMergeHistoryByContact({
      key: "mergeHistoryByContact",
      value,
    });
    setLoadingMergeHistoryByContact(false);
  }

  // async function handleDownloadLimit(value) {
  //   setdownloadLimit(value);
  //   setLoadingdownloadLimit(true);
  //   await updatedownloadLimit({
  //     key: "downloadLimit",
  //     value,
  //   });
  //   setLoadingdownloadLimit(false);
  // }

  async function handleChangeEfiClientid(value) {
    setEfiClientidType(value);
    setLoadingEfiClientidType(true);
    await updateeficlientid({
      key: 'eficlientid',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingEfiClientidType(false);
  }

async function handleCopyContactPrefix(value) {
  setCopyContactPrefix(value);
  setLoadingCopyContactPrefix(true);
  await update({
    column: "copyContactPrefix",
    data: value
  });
  setLoadingCopyContactPrefix(false);
}

  async function handleChangeEfiClientsecret(value) {
    setEfiClientsecretType(value);
    setLoadingEfiClientsecretType(true);
    await updateeficlientsecret({
      key: 'eficlientsecret',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingEfiClientsecretType(false);
  }

  async function handleChangeEfiChavepix(value) {
    setEfiChavepixType(value);
    setLoadingEfiChavepixType(true);
    await updateefichavepix({
      key: 'efichavepix',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingEfiChavepixType(false);
  }

  async function handleChangempaccesstoken(value) {
    setmpaccesstokenType(value);
    setLoadingmpaccesstokenType(true);
    await updatempaccesstoken({
      key: 'mpaccesstoken',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingmpaccesstokenType(false);
  }

  async function handleChangestripeprivatekey(value) {
    setstripeprivatekeyType(value);
    setLoadingstripeprivatekeyType(true);
    await updatestripeprivatekey({
      key: 'stripeprivatekey',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingstripeprivatekeyType(false);
  }

  async function handleChangeasaastoken(value) {
    setasaastokenType(value);
    setLoadingasaastokenType(true);
    await updateasaastoken({
      key: 'asaastoken',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingasaastokenType(false);
  }

  function handleSmtpFieldChange(key, value, setter, loadingSetter) {
    setter(value);

    if (smtpDebounceTimers.current[key]) {
      clearTimeout(smtpDebounceTimers.current[key]);
    }

    loadingSetter(true);
    smtpDebounceTimers.current[key] = setTimeout(async () => {
      try {
        await updateUserCreation({
          key,
          value,
        });
        toast.success('Operação atualizada com sucesso.');
      } finally {
        loadingSetter(false);
      }
    }, 800);
  }

  async function handleSendTestEmail() {
    if (!testEmailTo) {
      toast.error("Informe um e-mail para teste.");
      return;
    }

    setSendingTestEmail(true);
    try {
      await sendTestEmail(testEmailTo, testEmailLang);
      toast.success("E-mail de teste enviado com sucesso.");
    } finally {
      setSendingTestEmail(false);
    }
  }

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      column: "userRating",
      data: value
    });
    setLoadingUserRating(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      column: "scheduleType",
      data: value
    });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === "function") {
      scheduleTypeChanged(value);
    }
  }

  async function handleCopyContactPrefix(value) {
    setCopyContactPrefix(value);
    setLoadingCopyContactPrefix(true);
    await update({
      column: "copyContactPrefix",
      data: value
    });
    setLoadingCopyContactPrefix(false);
  }

  async function handleChatBotType(value) {
    setChatBotType(value);
    await update({
      column: "chatBotType",
      data: value
    });
    if (typeof scheduleTypeChanged === "function") {
      setChatBotType(value);
    }
  }

  async function handleLGPDMessage(value) {
    setLGPDMessage(value);
    setLoadingLGPDMessage(true);
    await update({
      column: "lgpdMessage",
      data: value
    });
    setLoadingLGPDMessage(false);
  }

  async function handletransferMessage(value) {
    setTransferMessage(value);
    setLoadingTransferMessage(true);
    await update({
      column: "transferMessage",
      data: value
    });
    setLoadingTransferMessage(false);
  }

  async function handleGreetingAcceptedMessage(value) {
    setGreetingAcceptedMessage(value);
    setLoadingGreetingAcceptedMessage(true);
    await update({
      column: "greetingAcceptedMessage",
      data: value
    });
    setLoadingGreetingAcceptedMessage(false);
  }

  async function handleAcceptCallWhatsappMessage(value) {
    setAcceptCallWhatsappMessage(value);
    setLoadingAcceptCallWhatsappMessage(true);
    await update({
      column: "AcceptCallWhatsappMessage",
      data: value
    });
    setLoadingAcceptCallWhatsappMessage(false);
  }

  async function handlesendQueuePositionMessage(value) {
    setSendQueuePositionMessage(value);
    setLoadingSendQueuePositionMessage(true);
    await update({
      column: "sendQueuePositionMessage",
      data: value
    });
    setLoadingSendQueuePositionMessage(false);
  }

  async function handleShowNotificationPending(value) {
    setShowNotificationPending(value);
    setLoadingShowNotificationPending(true);
    await update({
      column: "showNotificationPending",
      data: value
    });
    setLoadingShowNotificationPending(false);
  }



  // Debounce timer para período de tolerância
  const gracePeriodDebounceRef = useRef(null);
  const whatsappGracePeriodDebounceRef = useRef(null);

  // Cleanup do timer quando o componente for desmontado
  useEffect(() => {
    return () => {
      if (gracePeriodDebounceRef.current) {
        clearTimeout(gracePeriodDebounceRef.current);
      }
      if (whatsappGracePeriodDebounceRef.current) {
        clearTimeout(whatsappGracePeriodDebounceRef.current);
      }
      if (openaiTokenDebounceRef.current) {
        clearTimeout(openaiTokenDebounceRef.current);
      }
    };
  }, []);

  function handleOpenaiToken(value) {
    setOpenaiToken(value);

    if (openaiTokenDebounceRef.current) {
      clearTimeout(openaiTokenDebounceRef.current);
    }

    openaiTokenDebounceRef.current = setTimeout(async () => {
      setLoadingOpenaiToken(true);
      try {
        await update({
          column: "openaiToken",
          data: value
        });
      } catch (error) {
        console.error("Erro ao atualizar token OpenAI:", error);
      } finally {
        setLoadingOpenaiToken(false);
      }
    }, 800);
  }

  function handleGracePeriodDays(value) {
    setGracePeriodDays(value);

    // Cancelar timer anterior se existir
    if (gracePeriodDebounceRef.current) {
      clearTimeout(gracePeriodDebounceRef.current);
    }

    // Criar novo timer para fazer a chamada de API após 800ms de inatividade
    gracePeriodDebounceRef.current = setTimeout(async () => {
      setLoadingGracePeriodDays(true);
      try {
        await update({
          column: "planExpiryGracePeriodDays",
          data: value
        });
      } catch (error) {
        console.error("Erro ao atualizar período de tolerância:", error);
      } finally {
        setLoadingGracePeriodDays(false);
      }
    }, 800);
  }

  function handleWhatsappDisconnectGracePeriodDays(value) {
    setWhatsappDisconnectGracePeriodDays(value);

    // Cancelar timer anterior se existir
    if (whatsappGracePeriodDebounceRef.current) {
      clearTimeout(whatsappGracePeriodDebounceRef.current);
    }

    // Criar novo timer para fazer a chamada de API após 800ms de inatividade
    whatsappGracePeriodDebounceRef.current = setTimeout(async () => {
      setLoadingWhatsappDisconnectGracePeriodDays(true);
      try {
        await update({
          column: "whatsappDisconnectGracePeriodDays",
          data: value
        });
      } catch (error) {
        console.error("Erro ao atualizar período de tolerância WhatsApp:", error);
      } finally {
        setLoadingWhatsappDisconnectGracePeriodDays(false);
      }
    }, 800);
  }

  async function handleDisconnectWhatsappOnExpiry(value) {
    setDisconnectWhatsappOnExpiry(value);
    setLoadingDisconnectWhatsappOnExpiry(true);
    await update({
      column: "disconnectWhatsappOnExpiry",
      data: value ? "true" : "false"
    });
    setLoadingDisconnectWhatsappOnExpiry(false);
  }

  async function handleLGPDLink(value) {
    setLGPDLink(value);
    setLoadingLGPDLink(true);
    await update({
      column: "lgpdLink",
      data: value
    });
    setLoadingLGPDLink(false);
  }

  async function handleLGPDDeleteMessage(value) {
    setLGPDDeleteMessage(value);
    setLoadingLGPDDeleteMessage(true);
    await update({
      column: "lgpdDeleteMessage",
      data: value
    });
    setLoadingLGPDDeleteMessage(false);
  }

  async function handleLGPDConsent(value) {
    setLGPDConsent(value);
    setLoadingLGPDConsent(true);
    await update({
      column: "lgpdConsent",
      data: value
    });
    setLoadingLGPDConsent(false);
  }

  async function handleLGPDHideNumber(value) {
    setLGPDHideNumber(value);
    setLoadingLGPDHideNumber(true);
    await update({
      column: "lgpdHideNumber",
      data: value
    });
    setLoadingLGPDHideNumber(false);
  }

  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      column: "sendGreetingAccepted",
      data: value
    });
    setLoadingSendGreetingAccepted(false);
  }

  async function handleUserRandom(value) {
    setUserRandom(value);
    setLoadingUserRandom(true);
    await update({
      column: "userRandom",
      data: value
    });
    setLoadingUserRandom(false);
  }

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      column: "sendMsgTransfTicket",
      data: value
    });
    setLoadingSettingsTransfTicket(false);
  }

  async function handleAcceptCallWhatsapp(value) {
    setAcceptCallWhatsapp(value);
    setLoadingAcceptCallWhatsapp(true);
    await update({
      column: "acceptCallWhatsapp",
      data: value
    });
    setLoadingAcceptCallWhatsapp(false);
  }

  async function handleSendSignMessage(value) {
    setSendSignMessage(value);
    setLoadingSendSignMessage(true);
    await update({
      column: "sendSignMessage",
      data: value
    });
    localStorage.setItem("sendSignMessage", value === "enabled" ? true : false); //atualiza localstorage para sessão
    setLoadingSendSignMessage(false);
  }

  async function handleAutoCapitalizeMessage(value) {
    setAutoCapitalizeMessage(value);
    setLoadingAutoCapitalizeMessage(true);
    await update({
      column: "autoCapitalizeMessage",
      data: value
    });
    setLoadingAutoCapitalizeMessage(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      column: "sendGreetingMessageOneQueues",
      data: value
    });
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleSendQueuePosition(value) {
    setSendQueuePosition(value);
    setLoadingSendQueuePosition(true);
    await update({
      column: "sendQueuePosition",
      data: value
    });
    setLoadingSendQueuePosition(false);
  }

  async function handleSendFarewellWaitingTicket(value) {
    setSendFarewellWaitingTicket(value);
    setLoadingSendFarewellWaitingTicket(true);
    await update({
      column: "sendFarewellWaitingTicket",
      data: value
    });
    setLoadingSendFarewellWaitingTicket(false);
  }

  async function handleEnableLGPD(value) {
    setEnableLGPD(value);
    setLoadingEnableLGPD(true);
    await update({
      column: "enableLGPD",
      data: value
    });
    setLoadingEnableLGPD(false);
  }

  async function handleRequiredTag(value) {
    setRequiredTag(value);
    setLoadingRequiredTag(true);
    await update({
      column: "requiredTag",
      data: value,
    });
    setLoadingRequiredTag(false);
  }

  async function handleCloseTicketOnTransfer(value) {
    setCloseTicketOnTransfer(value);
    setLoadingCloseTicketOnTransfer(true);
    await update({
      column: "closeTicketOnTransfer",
      data: value,
    });
    setLoadingCloseTicketOnTransfer(false);
  }

  async function handleDirectTicketsToWallets(value) {
    setDirectTicketsToWallets(value);
    setLoadingDirectTicketsToWallets(true);
    await update({
      column: "DirectTicketsToWallets",
      data: value,
    });
    setLoadingDirectTicketsToWallets(false);
  }

  function handleTermsFileChange(event) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.name.endsWith(".docx")) {
        setTermsFile(selectedFile);
        setTermsFileName(selectedFile.name);
      } else {
        toast.error(i18n.t("termsOfUse.invalidFileType"));
        event.target.value = "";
      }
    }
  }

  async function handleTermsUpload() {
    if (!termsFile) return;

    setUploadingTerms(true);
    try {
      const formData = new FormData();
      formData.append("typeArch", "terms");
      formData.append("file", termsFile);

      await api.post("/settings/terms-upload", formData);
      toast.success(i18n.t("termsOfUse.uploadSuccess"));
      setTermsFile(null);
      setTermsFileName("");
    } catch (err) {
      toast.error(i18n.t("termsOfUse.uploadError"));
    } finally {
      setUploadingTerms(false);
    }
  }

  async function handleTermsPreview() {
    setLoadingPreview(true);
    try {
      const { data } = await api.get("/settings/terms");
      if (data.html) {
        setTermsPreviewHtml(data.html);
        setTermsPreviewOpen(true);
      } else {
        toast.error(i18n.t("termsOfUse.previewEmpty"));
      }
    } catch (err) {
      toast.error(i18n.t("termsOfUse.previewError"));
    } finally {
      setLoadingPreview(false);
    }
  }

  return (
    <>
      <Grid spacing={3} container>

        {/* CRIAÇÃO DE COMPANY/USERS */}
        {isMasterCompany() ?
          <Grid xs={12} sm={6} md={4} item>
            <FormControl className={classes.selectContainer}>
              <InputLabel id="UserCreation-label">
                {i18n.t("settings.settings.options.creationCompanyUser")}
              </InputLabel>
              <Select
                labelId="UserCreation-label"
                value={userCreation}
                onChange={async (e) => {
                  handleChangeUserCreation(e.target.value);
                }}
              >
                <MenuItem value={"disabled"}>
                  {i18n.t("settings.settings.options.disabled")}
                </MenuItem>
                <MenuItem value={"enabled"}>
                  {i18n.t("settings.settings.options.enabled")}
                </MenuItem>
              </Select>
              <FormHelperText>
                {loadingUserCreation &&
                  i18n.t("settings.settings.options.updating")}
              </FormHelperText>
            </FormControl>
          </Grid>
          : null}

        {/* #4155: MESCLAR HISTÓRICO ENTRE CONEXÕES DO CONTATO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="mergeHistoryByContact-label">
              {i18n.t("settings.settings.options.mergeHistoryByContact")}
            </InputLabel>
            <Select
              labelId="mergeHistoryByContact-label"
              value={mergeHistoryByContact}
              onChange={async (e) => {
                handleChangeMergeHistoryByContact(e.target.value);
              }}
            >
              <MenuItem value={"false"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"true"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingMergeHistoryByContact
                ? i18n.t("settings.settings.options.updating")
                : i18n.t("settings.settings.options.mergeHistoryByContactHelp")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* LIMITAR DOWNLOAD */}
        {/* {isSuper() ?
          <Grid xs={12} sm={6} md={4} item>
            <FormControl className={classes.selectContainer}>
              <InputLabel id="downloadLimit-label">
                Limite de Download de Arquivos (MB)
              </InputLabel>
              <Select
                labelId="downloadLimit-label"
                value={downloadLimit}
                size="small"
                onChange={async (e) => {
                  handleDownloadLimit(e.target.value);
                }}
              >
                <MenuItem value={"32"}>32</MenuItem>
                <MenuItem value={"64"}>64</MenuItem>
                <MenuItem value={"128"}>128</MenuItem>
                <MenuItem value={"256"}>256</MenuItem>
                <MenuItem value={"512"}>512</MenuItem>
                <MenuItem value={"1024"}>1024</MenuItem>
                <MenuItem value={"2048"}>2048</MenuItem>
              </Select>
              <FormHelperText>
                {loadingDownloadLimit && "Atualizando..."}
              </FormHelperText>
            </FormControl>
          </Grid>
          : null
        } */}

        {/* AVALIAÇÕES */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="ratings-label">{i18n.t("settings.settings.options.evaluations")}</InputLabel>
            <Select
              labelId="ratings-label"
              value={userRating}
              onChange={async (e) => {
                handleChangeUserRating(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingUserRating && i18n.t("settings.settings.options.evaluations")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* AGENDAMENTO DE EXPEDIENTE */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="schedule-type-label">
              {i18n.t("settings.settings.options.officeScheduling")}
            </InputLabel>
            <Select
              labelId="schedule-type-label"
              value={scheduleType}
              onChange={async (e) => {
                handleScheduleType(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={"queue"}>{i18n.t("settings.settings.options.queueManagement")}</MenuItem>
              <MenuItem value={"company"}>{i18n.t("settings.settings.options.companyManagement")}</MenuItem>
              <MenuItem value={"connection"}>{i18n.t("settings.settings.options.connectionManagement")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR SAUDAÇÃO AO ACEITAR O TICKET */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sendGreetingAccepted-label">
              {i18n.t("settings.settings.options.sendGreetingAccepted")}
            </InputLabel>
            <Select
              labelId="sendGreetingAccepted-label"
              value={SendGreetingAccepted}
              onChange={async (e) => {
                handleSendGreetingAccepted(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendGreetingAccepted && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ESCOLHER OPERADOR ALEATORIO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="userRandom-label">
              {i18n.t("settings.settings.options.userRandom")}
            </InputLabel>
            <Select
              labelId="userRandom-label"
              value={UserRandom}
              onChange={async (e) => {
                handleUserRandom(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingUserRandom && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR MENSAGEM DE TRANSFERENCIA DE SETOR/ATENDENTE */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sendMsgTransfTicket-label">
              {i18n.t("settings.settings.options.sendMsgTransfTicket")}
            </InputLabel>
            <Select
              labelId="sendMsgTransfTicket-label"
              value={SettingsTransfTicket}
              onChange={async (e) => {
                handleSettingsTransfTicket(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSettingsTransfTicket && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* TIPO DO BOT */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="schedule-type-label">{i18n.t("settings.settings.options.chatBotType")}</InputLabel>
            <Select
              labelId="schedule-type-label"
              value={chatBotType}
              onChange={async (e) => {
                handleChatBotType(e.target.value);
              }}
            >
              <MenuItem value={"text"}>Texto</MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* AVISO SOBRE LIGAÇÃO DO WHATSAPP */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="acceptCallWhatsapp-label">
              {i18n.t("settings.settings.options.acceptCallWhatsapp")}
            </InputLabel>
            <Select
              labelId="acceptCallWhatsapp-label"
              value={AcceptCallWhatsapp}
              onChange={async (e) => {
                handleAcceptCallWhatsapp(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingAcceptCallWhatsapp && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* HABILITAR PARA O ATENDENTE RETIRAR O ASSINATURA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sendSignMessage-label">
              {i18n.t("settings.settings.options.sendSignMessage")}
            </InputLabel>
            <Select
              labelId="sendSignMessage-label"
              value={sendSignMessage}
              onChange={async (e) => {
                handleSendSignMessage(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendSignMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* PRIMEIRA LETRA DA MENSAGEM EM MAIUSCULA (#4343) */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="autoCapitalizeMessage-label">
              {i18n.t("settings.settings.options.autoCapitalizeMessage")}
            </InputLabel>
            <Select
              labelId="autoCapitalizeMessage-label"
              value={autoCapitalizeMessage}
              onChange={async (e) => {
                handleAutoCapitalizeMessage(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingAutoCapitalizeMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR SAUDAÇÃO QUANDO HOUVER SOMENTE 1 FILA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sendGreetingMessageOneQueues-label">
              {i18n.t("settings.settings.options.sendGreetingMessageOneQueues")}
            </InputLabel>
            <Select
              labelId="sendGreetingMessageOneQueues-label"
              value={sendGreetingMessageOneQueues}
              onChange={async (e) => {
                handleSendGreetingMessageOneQueues(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendGreetingMessageOneQueues && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR MENSAGEM COM A POSIÇÃO DA FILA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sendQueuePosition-label">
              {i18n.t("settings.settings.options.sendQueuePosition")}
            </InputLabel>
            <Select
              labelId="sendQueuePosition-label"
              value={sendQueuePosition}
              onChange={async (e) => {
                handleSendQueuePosition(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendQueuePosition && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR MENSAGEM DE DESPEDIDA NO AGUARDANDO */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="sendFarewellWaitingTicket-label">
              {i18n.t("settings.settings.options.sendFarewellWaitingTicket")}
            </InputLabel>
            <Select
              labelId="sendFarewellWaitingTicket-label"
              value={sendFarewellWaitingTicket}
              onChange={async (e) => {
                handleSendFarewellWaitingTicket(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>
                {i18n.t("settings.settings.options.disabled")}
              </MenuItem>
              <MenuItem value={"enabled"}>
                {i18n.t("settings.settings.options.enabled")}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendFarewellWaitingTicket && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="enableLGPD-label"> {i18n.t("settings.settings.options.enableLGPD")}</InputLabel>
            <Select
              labelId="enableLGPD-label"
              value={enableLGPD}
              onChange={async (e) => {
                handleEnableLGPD(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingEnableLGPD && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="requiredTag-label"> {i18n.t("settings.settings.options.requiredTag")}</InputLabel>
            <Select
              labelId="requiredTag-label"
              value={requiredTag}
              onChange={async (e) => {
                handleRequiredTag(e.target.value);
              }}
            >
              <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={"enabled"}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingRequiredTag && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="closeTicketOnTransfer-label"> {i18n.t("settings.settings.options.closeTicketOnTransfer")}</InputLabel>
            <Select
              labelId="closeTicketOnTransfer-label"
              value={closeTicketOnTransfer}
              onChange={async (e) => {
                handleCloseTicketOnTransfer(e.target.value);
              }}
            >
              <MenuItem value={false}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={true}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingCloseTicketOnTransfer && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="showNotificationPending-label"> {i18n.t("settings.settings.options.showNotificationPending")}</InputLabel>
            <Select
              labelId="showNotificationPending-label"
              value={showNotificationPending}
              onChange={async (e) => {
                handleShowNotificationPending(e.target.value);
              }}
            >
              <MenuItem value={false}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={true}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingShowNotificationPending && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={4} item style={{ display: "flex", alignItems: "center" }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<NotificationsActiveIcon />}
            onClick={async () => {
              if (!("Notification" in window)) {
                toast.error(i18n.t("settings.settings.options.testNotificationUnsupported"));
                return;
              }
              if (Notification.permission === "denied") {
                toast.error(i18n.t("settings.settings.options.testNotificationBlocked"));
                return;
              }
              const sendNotification = async () => {
                const title = i18n.t("settings.settings.options.testNotificationTitle");
                const options = {
                  body: i18n.t("settings.settings.options.testNotificationBody"),
                  icon: "/android-chrome-192x192.png",
                  tag: "test-notification",
                };
                const reg = await navigator.serviceWorker.ready;
                await reg.showNotification(title, options);
                toast.success(i18n.t("settings.settings.options.testNotificationSuccess"));
              };
              if (Notification.permission === "granted") {
                await sendNotification();
                return;
              }
              const permission = await Notification.requestPermission();
              if (permission === "granted") {
                await sendNotification();
              } else {
                toast.error(i18n.t("settings.settings.options.testNotificationBlocked"));
              }
            }}
          >
            {i18n.t("settings.settings.options.testNotification")}
          </Button>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id="DirectTicketsToWallets-label"> {i18n.t("settings.settings.options.DirectTicketsToWallets")}</InputLabel>
            <Select
              labelId="DirectTicketsToWallets-label"
              value={directTicketsToWallets}
              onChange={async (e) => {
                handleDirectTicketsToWallets(e.target.value);
              }}
            >
              <MenuItem value={false}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
              <MenuItem value={true}>{i18n.t("settings.settings.options.enabled")}</MenuItem>
            </Select>
            <FormHelperText>
              {loadingDirectTicketsToWallets && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <br></br>

      {/* CONFIGURAÇÕES DE VENCIMENTO DO PLANO - APENAS EMPRESA ADMIN */}
      {isAdminCompany() && (
        <>
          <Grid spacing={3} container style={{ marginBottom: 10 }}>
            <Tabs
              indicatorColor='primary'
              textColor='primary'
              scrollButtons='on'
              variant='scrollable'
              className={classes.tab}
              style={{
                marginBottom: 20,
                marginTop: 20,
              }}
            >
              <Tab label={`⏰ ${i18n.t("settings.settings.options.planExpiryTitle")}`} />
            </Tabs>

            {/* PERÍODO DE TOLERÂNCIA EM DIAS - SISTEMA */}
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.selectContainer}>
                <TextField
                  id="gracePeriodDays"
                  name="gracePeriodDays"
                  label={i18n.t("settings.settings.options.gracePeriodDays")}
                  variant="outlined"
                  type="number"
                  value={gracePeriodDays}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Validar se é um número positivo
                    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 9999)) {
                      handleGracePeriodDays(value);
                    }
                  }}
                  inputProps={{
                    min: 0,
                    max: 9999,
                    step: 1
                  }}
                  placeholder="7"
                  disabled={loadingGracePeriodDays}
                />
                <FormHelperText>
                  {loadingGracePeriodDays && i18n.t("settings.settings.options.updating")}
                  {!loadingGracePeriodDays && i18n.t("settings.settings.options.gracePeriodHelp")}
                </FormHelperText>
              </FormControl>
            </Grid>

            {/* PERÍODO DE TOLERÂNCIA EM DIAS - WHATSAPP */}
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.selectContainer}>
                <TextField
                  id="whatsappDisconnectGracePeriodDays"
                  name="whatsappDisconnectGracePeriodDays"
                  label={i18n.t("settings.settings.options.whatsappDisconnectGracePeriodDays")}
                  variant="outlined"
                  type="number"
                  value={whatsappDisconnectGracePeriodDays}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Validar se é um número positivo
                    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 9999)) {
                      handleWhatsappDisconnectGracePeriodDays(value);
                    }
                  }}
                  inputProps={{
                    min: 0,
                    max: 9999,
                    step: 1
                  }}
                  placeholder="3"
                  disabled={loadingWhatsappDisconnectGracePeriodDays}
                />
                <FormHelperText>
                  {loadingWhatsappDisconnectGracePeriodDays && i18n.t("settings.settings.options.updating")}
                  {!loadingWhatsappDisconnectGracePeriodDays && "Quantos dias após o vencimento para desconectar WhatsApp"}
                </FormHelperText>
              </FormControl>
            </Grid>

            {/* DESCONECTAR WHATSAPP AUTOMATICAMENTE */}
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.selectContainer}>
                <InputLabel id="disconnectWhatsappOnExpiry-label">{i18n.t("settings.settings.options.disconnectWhatsappOnExpiry")}</InputLabel>
                <Select
                  labelId="disconnectWhatsappOnExpiry-label"
                  value={disconnectWhatsappOnExpiry}
                  onChange={(e) => {
                    handleDisconnectWhatsappOnExpiry(e.target.value);
                  }}
                >
                  <MenuItem value={false}>❌ {i18n.t("settings.settings.options.whatsappDisconnectNo")}</MenuItem>
                  <MenuItem value={true}>✅ {i18n.t("settings.settings.options.whatsappDisconnectYes")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingDisconnectWhatsappOnExpiry && i18n.t("settings.settings.options.updating")}
                  {!loadingDisconnectWhatsappOnExpiry && i18n.t("settings.settings.options.disconnectWhatsappHelp")}
                </FormHelperText>
              </FormControl>
            </Grid>

            {/* INFO SOBRE AS CONFIGURAÇÕES */}
            <Grid xs={12} sm={12} md={4} item>
              <div className={classes.infoBox}>
                <h4 className={classes.infoTitle}>ℹ️ {i18n.t("settings.settings.options.planExpiryInfoTitle")}</h4>
                <p className={classes.infoText}>
                  • <strong>{i18n.t("settings.settings.options.gracePeriodDays")}:</strong> {i18n.t("settings.settings.options.planExpiryInfoTolerance")}
                </p>
                <p className={classes.infoText}>
                  • <strong>WhatsApp:</strong> {i18n.t("settings.settings.options.planExpiryInfoWhatsapp")}
                </p>
                <p className={classes.infoText}>
                  • <strong>Bloqueio:</strong> {i18n.t("settings.settings.options.planExpiryInfoBlocking")}
                </p>
                <p className={classes.infoText}>
                  • <strong>{i18n.t("settings.settings.tabs.options")}:</strong> {i18n.t("settings.settings.options.planExpiryInfoConfig")}
                </p>
              </div>
            </Grid>
          </Grid>
          <br></br>
        </>
      )}

      {/* CONFIGURAÇÃO DE IA */}
      <Grid spacing={3} container style={{ marginBottom: 10 }}>
        <Tabs
          indicatorColor='primary'
          textColor='primary'
          scrollButtons='on'
          variant='scrollable'
          className={classes.tab}
          style={{
            marginBottom: 20,
            marginTop: 20,
          }}
        >
          <Tab label='Integrações IA' />
        </Tabs>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="openaiToken"
              name="openaiToken"
              margin="dense"
              label="Token OpenAI"
              variant="outlined"
              type="password"
              value={openaiToken}
              placeholder="sk-proj-..."
              onChange={(e) => handleOpenaiToken(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      title="Obter token no site da OpenAI"
                      onClick={() => window.open("https://platform.openai.com/api-keys", "_blank")}
                    >
                      <OpenInNewIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              disabled={loadingOpenaiToken}
            />
            <FormHelperText>
              {loadingOpenaiToken ? "Salvando..." : "Usado para transcrição de áudio e outros serviços de IA. Deixe vazio para desabilitar."}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <br></br>

      {/* CONFIGURAÇÃO SIGLA PARA CÓPIA DE CONTATOS */}
      <Grid spacing={3} container style={{ marginBottom: 10 }}>
                  <Tabs
            indicatorColor='primary'
            textColor='primary'
            scrollButtons='on'
            variant='scrollable'
            className={classes.tab}
            style={{
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <Tab label='Configuração de Sigla para Copia de Contato' />
          </Tabs>
        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="copyContactPrefix"
              name="copyContactPrefix"
              margin="dense"
              label={i18n.t("settings.settings.options.copyContactPrefix")}
              variant="outlined"
              value={copyContactPrefix}
              placeholder={i18n.t("settings.settings.options.copyContactPrefixPlaceholder")}
              onChange={async (e) => {
                handleCopyContactPrefix(e.target.value);
              }}
                InputLabelProps={{
    shrink: true,
  }}
            />
            <FormHelperText>
              {loadingCopyContactPrefix && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>

      
      {/*-----------------LGPD-----------------*/}
      {enableLGPD === "enabled" && (
        <>
          <Grid spacing={3} container
            style={{ marginBottom: 10 }}>
            <Tabs
              value={0}
              indicatorColor="primary"
              textColor="primary"
              scrollButtons="on"
              variant="scrollable"
              className={classes.tab}
            >
              <Tab

                label={i18n.t("settings.settings.LGPD.title")} />

            </Tabs>
          </Grid>
          <Grid spacing={1} container>
            <Grid xs={12} sm={6} md={12} item>
              <FormControl className={classes.selectContainer}>
                <TextField
                  id="lgpdMessage"
                  name="lgpdMessage"
                  margin="dense"
                  multiline
                  rows={3}
                  label={i18n.t("settings.settings.LGPD.welcome")}
                  variant="outlined"
                  value={lgpdMessage}
                  onChange={async (e) => {
                    handleLGPDMessage(e.target.value);
                  }}
                >
                </TextField>
                <FormHelperText>
                  {loadinglgpdMessage && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} md={12} item>
              <FormControl className={classes.selectContainer}>
                <TextField
                  id="lgpdLink"
                  name="lgpdLink"
                  margin="dense"
                  label={i18n.t("settings.settings.LGPD.linkLGPD")}
                  variant="outlined"
                  value={lgpdLink}
                  onChange={async (e) => {
                    handleLGPDLink(e.target.value);
                  }}
                >
                </TextField>
                <FormHelperText>
                  {loadingLGPDLink && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            {/* LGPD Manter ou nao mensagem deletada pelo contato */}
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.selectContainer}>
                <InputLabel id="lgpdDeleteMessage-label">{i18n.t("settings.settings.LGPD.obfuscateMessageDelete")}</InputLabel>
                <Select
                  labelId="lgpdDeleteMessage-label"
                  value={lgpdDeleteMessage}
                  onChange={async (e) => {
                    handleLGPDDeleteMessage(e.target.value);
                  }}
                >
                  <MenuItem value={"disabled"}>{i18n.t("settings.settings.LGPD.disabled")}</MenuItem>
                  <MenuItem value={"enabled"}>{i18n.t("settings.settings.LGPD.enabled")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingLGPDDeleteMessage && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            {/* LGPD Sempre solicitar confirmaçao / conscentimento dos dados */}
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.selectContainer}>
                <InputLabel id="lgpdConsent-label">
                  {i18n.t("settings.settings.LGPD.alwaysConsent")}
                </InputLabel>
                <Select
                  labelId="lgpdConsent-label"
                  value={lgpdConsent}
                  onChange={async (e) => {
                    handleLGPDConsent(e.target.value);
                  }}
                >
                  <MenuItem value={"disabled"}>{i18n.t("settings.settings.LGPD.disabled")}</MenuItem>
                  <MenuItem value={"enabled"}>{i18n.t("settings.settings.LGPD.enabled")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingLGPDConsent && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
            {/* LGPD Ofuscar número telefone para usuários */}
            <Grid xs={12} sm={6} md={4} item>
              <FormControl className={classes.selectContainer}>
                <InputLabel id="lgpdHideNumber-label">
                  {i18n.t("settings.settings.LGPD.obfuscatePhoneUser")}
                </InputLabel>
                <Select
                  labelId="lgpdHideNumber-label"
                  value={lgpdHideNumber}
                  onChange={async (e) => {
                    handleLGPDHideNumber(e.target.value);
                  }}
                >
                  <MenuItem value={"disabled"}>{i18n.t("settings.settings.LGPD.disabled")}</MenuItem>
                  <MenuItem value={"enabled"}>{i18n.t("settings.settings.LGPD.enabled")}</MenuItem>
                </Select>
                <FormHelperText>
                  {loadingLGPDHideNumber && i18n.t("settings.settings.options.updating")}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </>
      )}

      <Grid spacing={3} container>
        {isSuper() ?
          <Tabs
            indicatorColor='primary'
            textColor='primary'
            scrollButtons='on'
            variant='scrollable'
            className={classes.tab}
            style={{
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <Tab label='SMTP Geral - Empresa Master' />
          </Tabs>
          : null}
      </Grid>

      <Grid spacing={3} container style={{ marginBottom: 10 }}>
        <Grid xs={12} sm={6} md={4} item>
          {isMasterCompany() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='smtpHost'
                name='smtpHost'
                margin='dense'
                label='SMTP Host'
                variant='outlined'
                value={smtpHost}
                onChange={(e) => {
                  handleSmtpFieldChange(
                    "smtpHost",
                    e.target.value,
                    setSmtpHost,
                    setLoadingSmtpHost
                  );
                }}
              />
              <FormHelperText>
                {loadingSmtpHost && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={6} md={2} item>
          {isMasterCompany() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='smtpPort'
                name='smtpPort'
                margin='dense'
                label='SMTP Porta'
                variant='outlined'
                value={smtpPort}
                onChange={(e) => {
                  handleSmtpFieldChange(
                    "smtpPort",
                    e.target.value,
                    setSmtpPort,
                    setLoadingSmtpPort
                  );
                }}
              />
              <FormHelperText>
                {loadingSmtpPort && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={6} md={3} item>
          {isMasterCompany() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='smtpUser'
                name='smtpUser'
                margin='dense'
                label='SMTP Usuario'
                variant='outlined'
                value={smtpUser}
                onChange={(e) => {
                  handleSmtpFieldChange(
                    "smtpUser",
                    e.target.value,
                    setSmtpUser,
                    setLoadingSmtpUser
                  );
                }}
              />
              <FormHelperText>
                {loadingSmtpUser && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={6} md={3} item>
          {isMasterCompany() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='smtpPass'
                name='smtpPass'
                margin='dense'
                label='SMTP Senha'
                type='password'
                variant='outlined'
                value={smtpPass}
                onChange={(e) => {
                  handleSmtpFieldChange(
                    "smtpPass",
                    e.target.value,
                    setSmtpPass,
                    setLoadingSmtpPass
                  );
                }}
              />
              <FormHelperText>
                {loadingSmtpPass && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={6} md={6} item>
          {isMasterCompany() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='smtpFrom'
                name='smtpFrom'
                margin='dense'
                label='SMTP Remetente'
                variant='outlined'
                value={smtpFrom}
                onChange={(e) => {
                  handleSmtpFieldChange(
                    "smtpFrom",
                    e.target.value,
                    setSmtpFrom,
                    setLoadingSmtpFrom
                  );
                }}
              />
              <FormHelperText>
                {loadingSmtpFrom && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={6} md={6} item>
          {isMasterCompany() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='frontendUrl'
                name='frontendUrl'
                margin='dense'
                label='URL Frontend'
                variant='outlined'
                value={frontendUrl}
                onChange={(e) => {
                  handleSmtpFieldChange(
                    "frontendUrl",
                    e.target.value,
                    setFrontendUrl,
                    setLoadingFrontendUrl
                  );
                }}
              />
              <FormHelperText>
                {loadingFrontendUrl
                  ? 'Atualizando...'
                  : 'Base usada nos links de e-mail do sistema'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={6} md={5} item>
          {isMasterCompany() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='testEmailTo'
                name='testEmailTo'
                margin='dense'
                label='E-mail para teste'
                variant='outlined'
                value={testEmailTo}
                onChange={(e) => setTestEmailTo(e.target.value)}
              />
              <FormHelperText>
                Informe um destinatario para validar o SMTP configurado acima
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={3} md={3} item>
          {isMasterCompany() ?
            <FormControl variant="outlined" margin="dense" className={classes.selectContainer}>
              <InputLabel id="testEmailLang-label">Idioma</InputLabel>
              <Select
                labelId="testEmailLang-label"
                id="testEmailLang"
                value={testEmailLang}
                onChange={(e) => setTestEmailLang(e.target.value)}
                label="Idioma"
              >
                <MenuItem value="pt">Portugues</MenuItem>
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="es">Espanol</MenuItem>
                <MenuItem value="ar">عربي</MenuItem>
              </Select>
              <FormHelperText>
                Idioma do e-mail de teste
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={3} md={4} item>
          {isMasterCompany() ?
            <FormControl className={classes.selectContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSendTestEmail}
                disabled={sendingTestEmail}
                style={{ marginTop: 16 }}
              >
                {sendingTestEmail ? "Enviando..." : "Enviar e-mail teste"}
              </Button>
            </FormControl>
            : null}
        </Grid>
      </Grid>

      <Grid spacing={3} container>
        {isSuper() ?
          <Tabs
            indicatorColor='primary'
            textColor='primary'
            scrollButtons='on'
            variant='scrollable'
            className={classes.tab}
            style={{
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <Tab label='Configuração Pix Efí (GerenciaNet)' />
          </Tabs>
          : null}
      </Grid>

      <Grid spacing={3} container style={{ marginBottom: 10 }}>
        <Grid xs={12} sm={6} md={6} item>
          {isSuper() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='eficlientid'
                name='eficlientid'
                margin='dense'
                label='Client ID'
                variant='outlined'
                value={eficlientidType}
                onChange={async (e) => {
                  handleChangeEfiClientid(e.target.value);
                }}
              ></TextField>
              <FormHelperText>
                {loadingEfiClientidType && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={6} md={6} item>
          {isSuper() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='eficlientsecret'
                name='eficlientsecret'
                margin='dense'
                label='Client Secret'
                variant='outlined'
                value={eficlientsecretType}
                onChange={async (e) => {
                  handleChangeEfiClientsecret(e.target.value);
                }}
              ></TextField>
              <FormHelperText>
                {loadingEfiClientsecretType && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
        <Grid xs={12} sm={12} md={12} item>
          {isSuper() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='efichavepix'
                name='efichavepix'
                margin='dense'
                label='Chave PIX'
                variant='outlined'
                value={efichavepixType}
                onChange={async (e) => {
                  handleChangeEfiChavepix(e.target.value);
                }}
              ></TextField>
              <FormHelperText>
                {loadingEfiChavepixType && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
      </Grid>

      <Grid spacing={3} container>
        {isSuper() ?
          <Tabs
            indicatorColor='primary'
            textColor='primary'
            scrollButtons='on'
            variant='scrollable'
            className={classes.tab}
            style={{
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <Tab label='Mercado Pago' />
          </Tabs>
          : null}
      </Grid>

      <Grid spacing={3} container style={{ marginBottom: 10 }}>
        <Grid xs={12} sm={12} md={12} item>
          {isSuper() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='mpaccesstoken'
                name='mpaccesstoken'
                margin='dense'
                label='Access Token'
                variant='outlined'
                value={mpaccesstokenType}
                onChange={async (e) => {
                  handleChangempaccesstoken(e.target.value);
                }}
              ></TextField>
              <FormHelperText>
                {loadingmpaccesstokenType && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
      </Grid>

      <Grid spacing={3} container>
        {isSuper() ?
          <Tabs
            indicatorColor='primary'
            textColor='primary'
            scrollButtons='on'
            variant='scrollable'
            className={classes.tab}
            style={{
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <Tab label='Stripe' />
          </Tabs>
          : null}
      </Grid>

      <Grid spacing={3} container style={{ marginBottom: 10 }}>
        <Grid xs={12} sm={12} md={12} item>
          {isSuper() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='stripeprivatekey'
                name='stripeprivatekey'
                margin='dense'
                label='Stripe Private Key'
                variant='outlined'
                value={stripeprivatekeyType}
                onChange={async (e) => {
                  handleChangestripeprivatekey(e.target.value);
                }}
              ></TextField>
              <FormHelperText>
                {loadingstripeprivatekeyType && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
      </Grid>

      <Grid spacing={3} container>
        {isSuper() ?
          <Tabs
            indicatorColor='primary'
            textColor='primary'
            scrollButtons='on'
            variant='scrollable'
            className={classes.tab}
            style={{
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <Tab label='ASAAS' />
          </Tabs>
          : null}
      </Grid>

      <Grid spacing={3} container style={{ marginBottom: 10 }}>
        <Grid xs={12} sm={12} md={12} item>
          {isSuper() ?
            <FormControl className={classes.selectContainer}>
              <TextField
                id='asaastoken'
                name='asaastoken'
                margin='dense'
                label='Token Asaas'
                variant='outlined'
                value={asaastokenType}
                onChange={async (e) => {
                  handleChangeasaastoken(e.target.value);
                }}
              ></TextField>
              <FormHelperText>
                {loadingasaastokenType && 'Atualizando...'}
              </FormHelperText>
            </FormControl>
            : null}
        </Grid>
      </Grid>

      <Grid spacing={1} container>
        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="transferMessage"
              name="transferMessage"
              margin="dense"
              multiline
              rows={3}
              label={i18n.t("settings.settings.customMessages.transferMessage")}
              variant="outlined"
              value={transferMessage}
              required={SettingsTransfTicket === "enabled"}
              onChange={async (e) => {
                handletransferMessage(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingTransferMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="greetingAcceptedMessage"
              name="greetingAcceptedMessage"
              margin="dense"
              multiline
              rows={3}
              label={i18n.t("settings.settings.customMessages.greetingAcceptedMessage")}
              variant="outlined"
              value={greetingAcceptedMessage}
              required={SendGreetingAccepted === "enabled"}
              onChange={async (e) => {
                handleGreetingAcceptedMessage(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingGreetingAcceptedMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="AcceptCallWhatsappMessage"
              name="AcceptCallWhatsappMessage"
              margin="dense"
              multiline
              rows={3}
              label={i18n.t("settings.settings.customMessages.AcceptCallWhatsappMessage")}
              variant="outlined"
              required={AcceptCallWhatsapp === "disabled"}
              value={AcceptCallWhatsappMessage}
              onChange={async (e) => {
                handleAcceptCallWhatsappMessage(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingAcceptCallWhatsappMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="sendQueuePositionMessage"
              name="sendQueuePositionMessage"
              margin="dense"
              multiline
              required={sendQueuePosition === "enabled"}
              rows={3}
              label={i18n.t("settings.settings.customMessages.sendQueuePositionMessage")}
              variant="outlined"
              value={sendQueuePositionMessage}
              onChange={async (e) => {
                handlesendQueuePositionMessage(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingSendQueuePositionMessage && i18n.t("settings.settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>

      {/* TERMOS DE USO - APENAS EMPRESA MASTER */}
      {isAdminCompany() && (
        <>
          <Grid spacing={3} container style={{ marginBottom: 10 }}>
            <Tabs
              indicatorColor="primary"
              textColor="primary"
              scrollButtons="on"
              variant="scrollable"
              className={classes.tab}
              style={{
                marginBottom: 20,
                marginTop: 20,
              }}
            >
              <Tab label={i18n.t("termsOfUse.settingsTitle")} />
            </Tabs>

            <Grid xs={12} sm={12} md={8} item>
              <div className={classes.termsUploadBox}>
                <Typography variant="body2" color="textSecondary">
                  {i18n.t("termsOfUse.uploadDescription")}
                </Typography>

                <div className={classes.termsFileRow}>
                  <input
                    accept=".docx"
                    style={{ display: "none" }}
                    id="terms-file-upload"
                    type="file"
                    onChange={handleTermsFileChange}
                  />
                  <label htmlFor="terms-file-upload">
                    <Button
                      variant="outlined"
                      component="span"
                      startIcon={<DescriptionIcon />}
                    >
                      {i18n.t("termsOfUse.selectFile")}
                    </Button>
                  </label>

                  {termsFileName && (
                    <div className={classes.termsFileName}>
                      <DescriptionIcon fontSize="small" />
                      <Typography variant="body2">{termsFileName}</Typography>
                    </div>
                  )}
                </div>

                <div className={classes.termsButtonRow}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={uploadingTerms ? <CircularProgress size={20} color="inherit" /> : <CloudUploadIcon />}
                    onClick={handleTermsUpload}
                    disabled={!termsFile || uploadingTerms}
                  >
                    {uploadingTerms
                      ? i18n.t("termsOfUse.uploading")
                      : i18n.t("termsOfUse.uploadButton")}
                  </Button>

                  <Button
                    variant="outlined"
                    startIcon={loadingPreview ? <CircularProgress size={20} /> : <VisibilityIcon />}
                    onClick={handleTermsPreview}
                    disabled={loadingPreview}
                  >
                    {i18n.t("termsOfUse.previewButton")}
                  </Button>
                </div>
              </div>

              <Dialog
                open={termsPreviewOpen}
                onClose={() => setTermsPreviewOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle>{i18n.t("termsOfUse.settingsTitle")}</DialogTitle>
                <DialogContent dividers>
                  <div
                    dangerouslySetInnerHTML={{ __html: termsPreviewHtml }}
                    style={{ lineHeight: 1.6 }}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setTermsPreviewOpen(false)} color="primary">
                    {i18n.t("termsOfUse.closeButton")}
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}
